module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d6e514636"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c7_r1#d7e40841",
      "id": "d14e734"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d6e515136"
    }
  }, [_c('span', {
    staticClass: "ic",
    attrs: {
      "id": "d14e737"
    }
  }, [_c('b', [_vm._v("T")])]), _vm._v("he day after his father’s conversation with Sergeant Rivas, Carlos Tejada broached the subject of going south at lunch with his wife. “I got another call from Granada this morning,” he said. “It seems they’re very anxious that there be an investigation of Aunt Rosalia’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e518836"
    }
  }, [_vm._v("Elena handed him a bowl of soup. “You’ve decided to put in for leave, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e519836"
    }
  }, [_vm._v("“I’m not sure. I wouldn’t mind putting in for leave if I thought Suárez would grant it, but it sounds like what they really want is for me to be transferred to Granada.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e521636"
    }
  }, [_vm._v("“Why would they want you to transfer?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e522436"
    }
  }, [_vm._v("“Sergeant Rivas wasn’t totally clear. I got the impression that my father was breathing down his neck, but I couldn’t tell if it was because he wanted an investigation—with me in charge—or because he didn’t want any investigation at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e524336"
    }
  }, [_vm._v("Elena considered. She had never fully grasped the subtleties of her husband’s relationship with his parents, and she weighed her next words carefully, making sure that her tone was neutral. “Surely your father would send you word if he really needed your help?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e526536"
    }
  }, [_vm._v("Tejada absentmindedly began to shred a roll into his soup. “He usually avoids doing anything if there’s a servant to do it for him.” He caught sight of his son’s wide eyes and smiled  crookedly. “I didn’t mean that. My father is a natural leader, and he’s very good at delegating things.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e529437"
    }
  }, [_vm._v("Elena laughed. Toño could not understand why, but he had the feeling that his father had deliberately made a joke. He tried to understand what was funny. “What’s ‘delegating’ mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e531037"
    }
  }, [_vm._v("“Getting somebody to do things for you, but in a good way. Never speak ill of your father when he’s old and helpless, Toño.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e532237"
    }
  }, [_vm._v("“I won’t,” Toño agreed readily, although he was comfortably certain that his father would never be old and helpless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e533637"
    }
  }, [_vm._v("“Do you think the colonel will agree to transfer you?” Elena asked, returning to the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e534637"
    }
  }, [_vm._v("Tejada shook his head. “The Guardia in Granada called Santander and asked him. He doesn’t want to put a new man in the mountains with winter coming on. So then they called me, to ask if I’d put in for leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e536737"
    }
  }, [_vm._v("“Isn’t that a bit discourteous to the colonel?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e537437"
    }
  }, [_vm._v("Tejada sighed. “Yes. It’s bad manners to poach another man’s officer, and they know it. That’s why I think my father’s leaning on them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e538937"
    }
  }, [_vm._v("“Will you do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e539637"
    }
  }, [_vm._v("The lieutenant shrugged. “I would want Toño to do the same for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e540937"
    }
  }, [_vm._v("“How long would you be gone?” asked Elena.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e541637"
    }
  }, [_vm._v("“I don’t know. I think Suárez would give me ten days, if I explained it was family business. Maybe two weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e543037"
    }
  }, [_vm._v("“Isn’t that a short time to conduct a serious investigation?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e543737"
    }
  }, [_vm._v("Her husband laughed. “That would barely give us time to finish the paperwork. This is just a formality. Besides I don’t want to be away from work for longer than that, and I didn’t think you’d want to be away for any length of time either so soon after Santander.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e545937"
    }
  }, [_vm._v("“You weren’t planning on all of us going?” exclaimed Elena.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e546437"
    }
  }, [_vm._v("“I wasn’t planning to go alone!” her husband retorted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e547137"
    }
  }, [_vm._v("Elena had little desire to travel all the way to Granada and  less to see her husband’s parents again, but she was gratified that he did not want to return to his family without her. It was good to know that he was not ashamed of her. She sought something positive to say. “Actually, I might know someone in Granada. There was a girl I knew at university, Cristina Encinas, whose family was from there. Her father was the director of some kind of school for orphans, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e551238"
    }
  }, [_vm._v("Although Tejada was generally unenthusiastic about his wife’s college friends, whom he grouped under the heading “rabble-rousing Commie malcontents,” he smiled encouragingly. “Maybe you could look her up,” he said. “Do you suppose she’s still teaching, or has she married?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e553938"
    }
  }, [_vm._v("“Cristina was studying medicine,” Elena corrected. “She was just friendly with teachers because of her father.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e555238"
    }
  }, [_vm._v("Tejada choked on his soup. "), _c('i', [_vm._v("A lady doctor, ")]), _vm._v("he thought. "), _c('i', [_vm._v("Oh, God, ")]), _vm._v("why "), _c('i', [_vm._v("can’t she have normal friends")]), _vm._v("? He wondered if perhaps it would be better to go to Granada on his own, sparing his wife his parents company, and vice versa. “Of course it would be a lot of traveling in a short time,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e558438"
    }
  }, [_vm._v("Toño had been following a private train of thought. Now he spoke up. “Granada is a long way away?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e559738"
    }
  }, [_vm._v("Elena nodded. “At least a day of travel.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e560438"
    }
  }, [_vm._v("“And "), _c('i', [_vm._v("if ")]), _vm._v("we went to Granada we would probably have to go on the train?” Toño’s face was a picture of innocent inquiry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e562138"
    }
  }, [_vm._v("His parents exchanged glances. “Undoubtedly,” his mother agreed gravely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e563138"
    }
  }, [_vm._v("Carlos Antonio gulped, unable to think of words to frame his request. His quivering body spoke more eloquently than words anyway. The lieutenant smiled. “I guess I’ll give the colonel a call this afternoon,” he said. “Maybe he won’t mind my taking some time off.”"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d6e565038"
    }
  }, [_vm._v("Toño was so pleased at the prospect of an actual train trip that he did not notice his parents were both rather nervous in the  week before their trip south. He had gathered that they were going to stay with his car-owning uncle, who lived with his wife and children with his father’s parents in Granada. The little boy was curious about meeting his father’s parents. He had enjoyed his stays with his mother’s parents the preceding Christmas, and again in August when they came from Salamanca to the seashore in Santander. Toño had liked them immensely and was happy to discover that he had more grandparents. He noticed, however, that his parents appeared determined to make sure that he was not disappointed by his new relatives. “I don’t know them very well. But I’m sure they’ll like you. After all, you’re their own flesh and blood,” his mother said. His father cautioned, “You have to remember that you’re the Fernándezes’ "), _c('i', [_vm._v("only ")]), _vm._v("grandchild. You have three older cousins, and these grandparents know them better. But I’m sure they’ll be very fond of you once they meet you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e573239"
    }
  }, [_vm._v("Toño attributed part of his mother’s irritability to unusual activity before their departure. She was suddenly intent on finishing a new dress for herself and a new suit for him. Toño thought she looked pretty in the dress and did not begrudge it to her, although he wished that she did not see a need to make new clothes for him as well. She was also in charge of most of their packing, and the preparations for closing their apartment during their absence. Toño remembered her being short-tempered before they had gone to Santander as well. He was fairly sure that she would become happy once they were well on their way. In fact, he could not understand how anyone going to ride in a sleeping compartment the length of Spain could "), _c('i', [_vm._v("not ")]), _vm._v("enjoy the trip.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e579639"
    }
  }, [_vm._v("He was up at sunrise on the day they began their journey. His father had somehow managed to have Don Eduardo, the mayor, drive them to the station in Torrelavega. Toño, sandwiched in the backseat between his mother and the trunks, sat very still during the long ride out of the valley of Liébana through the  narrow gorge that led to the coast. He was glad now of his new suit and his freshly cut hair, and was even able to share his mother’s regret that he could not wear new shoes to set off on the longest journey of his life. New clothes and grave behavior were an appropriate compliment to the grandeur of the means of transportation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e584940"
    }
  }, [_vm._v("They reached the station in good time for the 9:28 train to Madrid. Toño was fascinated by the hustle and bustle of boarding the train and enchanted by the compartment his father had reserved. His contentment was complete when his mother agreed that they could pull down the top bunk so that he could have it all to himself. At her suggestion, he climbed into his domain, took the pencils and drawing paper that she passed up to him, and began to draw a picture of the station.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e588340"
    }
  }, [_vm._v("Below him, his parents sank into the seats with sighs of relief. His mother leaned her throbbing temple against the cool glass and stared at the landscape without seeing it. Tejada watched the telephone poles click by, too tired to wonder if it would be possible to take a picture out the window that would be more than a meaningless blur. He took off his tricorn and tossed it onto his folded cloak. The cloak was far too heavy for this weather. Down here, away from the cool of the mountain patrol, switching to winter uniforms at the end of October was ridiculous. "), _c('i', [_vm._v("It may be hotter in Granada, ")]), _vm._v("he thought. "), _c('i', [_vm._v("Although I suppose I ")]), _c('i', [_vm._v("won’t have to wear the uniform. I’m visiting family, officially. And conducting ")]), _c('i', [_vm._v("an investigation for the Guardia. Unofficially? Or will it be ")]), _c('i', [_vm._v("officially? Will I have to wear a uniform? It’s only for two weeks. And ")]), _c('i', [_vm._v("Toño’s happy, bless him. They’ll like him. Who couldn’t notice what a ")]), _c('i', [_vm._v("good boy he is? Not like those brats of Juan’s. They ought to be proud of ")]), _c('i', [_vm._v("such a grandson. Even if he is Elena’s, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e595840"
    }
  }, [_vm._v("He looked at his wife. Her face was drawn with strain, and he knew that she dreaded the meeting with his family. He was not sure what they resented most about Elena: that she was from Salamanca, that her family was impoverished, or that she was a  leftist. (“A penniless foreign Red!” his brother had exclaimed on learning of his plans to marry Elena. “My God, Carlos, when you set out to annoy Mama and Papa, you don’t do it halfway!”) He spared a moment to hope that if she did follow through on her plans to look up her old classmate, his mother would never discover that she was visiting a woman doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e600041"
    }
  }, [_vm._v("He sighed. The visit to Granada was going to be difficult for her. But leaving her behind in Potes had been unthinkable. Tejada doubted that Potes’s guerillas would declare open war by attacking an officer’s family. Not when the Guardia had easy access to their own parents, siblings, friends, and lovers. Five years earlier he would have feared for Elena’s well-being alone in Potes, but now he knew that she would be equally secure, and probably considerably happier there. He had insisted on bringing her and Toño because he did not want to face his family on his own. He wanted to return home as a man in his own right, with the responsibility of a family, not as a prodigal younger son slinking back home at his father’s command."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d6e606041"
    }
  }, [_vm._v("Their train came into the Northern Station in Madrid, and the train to Granada left from Atocha, practically at the other end of the city. They had less than two hours scheduled to make their connection, and their train arrived nearly an hour late. Tejada was left with the nightmare of finding a porter and a taxi and making sure that all of their baggage made the transition from one train station to another along with them. The traffic was terrible, and Tejada, crammed into a corner of the cab with one arm locked around his son, was torn between the nerve-racking conviction that they were going to miss the train and the terror that their driver’s recklessness was going to kill them all. Toño was saucer eyed at his first glimpse of the capital and would happily have missed the train to spend the rest of the afternoon wandering around the city naming the make and model of every automobile they passed. Elena, who had spent  some of the happiest years of her life in Madrid before the war, was nearly as bad as her son. When they finally reached the Atocha station the two of them ambled through the crowds while Elena wistfully recounted anecdotes of her life in the city. “If we had a little more time, we could go see the Metro,” she told Toño regretfully. “That’s a train that runs in tunnels under the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e616042"
    }
  }, [_vm._v("Tejada turned away from the longing in her face. Her life in Madrid had belonged to a time before the war, and before him. He disliked thinking about the years she had spent as a teacher, a Socialist, and what the Reds had called a “liberated woman,” under any circumstances. He especially disliked thinking about them when he was late to catch a train to meet his family. He finally took Toño’s hand and all of the Tejadas ran for the train. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e619642"
    }
  }, [_vm._v("Toño thoroughly enjoyed the chance to run down the platform at full speed. Although his glimpse of Madrid had been fascinating, he was not unhappy to be once more ensconced in the upper bunk of a sleeping compartment, and was even resigned to his mother’s suggestion that he take a nap. "), _c('i', [_vm._v("Someday")]), _vm._v(", he thought drowsily, staring at the roof of the railroad car as it rolled south across La Mancha, "), _c('i', [_vm._v("I’m going to live in Madrid and ride ")]), _c('i', [_vm._v("the train every day.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e624042"
    }
  }, [_c('i', [_vm._v("Thank God we got through Madrid, ")]), _vm._v("Tejada thought. "), _c('i', [_vm._v("Now we ")]), _c('i', [_vm._v("should be all right, provided Juan got the letter about what time to meet ")]), _c('i', [_vm._v("us with the car. Elena would have liked more time in Madrid, but she ")]), _c('i', [_vm._v("wouldn’t want to hear all my mother would have to say about stopping ")]), _c('i', [_vm._v("in the capital. God, let them both be decent to Elena. It will be better this ")]), _c('i', [_vm._v("time than when we were just married. There’s Toño, and lots of things ")]), _c('i', [_vm._v("are different.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e627542"
    }
  }, [_c('i', [_vm._v("Perhaps if Carlos finishes this investigation quickly, we can spend a ")]), _c('i', [_vm._v("few days in Madrid on the way back, ")]), _vm._v("Elena thought, leaning against his shoulder. "), _c('i', [_vm._v("He must have seen how much Toño enjoyed seeing the ")]), _c('i', [_vm._v("city. It looks better than it did in ’39 at any rate. I wonder if it’s changed ")]), _c('i', [_vm._v("much? I hope Toño likes Granada. I wonder how Carlos’s parents will ")]), _c('i', [_vm._v(" treat him. I don’t care what they say to me, but please, God, don’t let ")]), _c('i', [_vm._v("them hurt Toño.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e631943"
    }
  }, [_vm._v("Their thoughts were not comfortable but the car was warm and the hardest part of the journey was over with, and they had been up since before dawn. Toño had been sound asleep for half an hour when Tejada dozed off with his head resting against his wife’s. He dreamed that he and his brother were playing tag as they had played when they were children, but that the game wound through the bomb-cratered streets of Madrid after the Civil War. Elena and Toño were hidden somewhere in the rubble and he had to win the game to find them. Finally, some while after her husband and son, Elena slid into an exhausted, dreamless sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e636243"
    }
  }, [_vm._v("Toño woke her a few minutes after nine o’clock because he was hungry. His parents took him to the dining car, which he compared minutely to descriptions in the books he’d had read to him. The Tejadas’ dinner was enlivened when Toño struck up a friendship with a group of soldiers heading south to Algeciras. To the little boy’s joy, one of them turned out to be the brakeman’s cousin, and volunteered to take him to go see the locomotive. His parents allowed him to go, on the condition that Private Ramos returned him by bedtime. Toño departed, ecstatic. When his parents were back in their compartment Tejada began to laugh. “I didn’t expect him to run away to join the army until he was eighteen!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e642843"
    }
  }, [_vm._v("“I didn’t expect it at all,” Elena said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e643543"
    }
  }, [_vm._v("“This is what comes of his having your republican instincts to fraternize.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e644543"
    }
  }, [_vm._v("“And your lack of distrust for men with guns!” Elena retorted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e645043"
    }
  }, [_vm._v("“He won’t come to any harm with them,” Tejada said soothingly. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e646143"
    }
  }, [_vm._v("“I know,” Elena sighed. “He’s getting very grown up, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e646643"
    }
  }, [_vm._v("“His first big trip away from home.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e647343"
    }
  }, [_vm._v("“Not really "), _c('i', [_vm._v("away")]), _vm._v(". Just to visit his grandparents,” Elena said heroically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e649044"
    }
  }, [_vm._v("Tejada nodded, and a little silence fell. After a minute or two the lieutenant said slowly, “I think it will be all right. My parents, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e650544"
    }
  }, [_vm._v("Elena knew he was speaking to reassure himself as much as her. “They’ll like Toño.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e651744"
    }
  }, [_vm._v("Tejada silently agreed. Then, looking out the window at the empty landscape he said slowly, “I think they’ll be all right about you—about us, I mean. After all, five years is a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e653244"
    }
  }, [_vm._v("Elena remembered a similar anxious conversation at the beginning of their honeymoon. She reached over and took his hand. “It doesn’t seem that long,” she said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e654544"
    }
  }, [_vm._v("He smiled back, remembering their last trip south as well. They had taken a night train then also and had enjoyed proving that although the bunks in the sleeping cars were narrow they definitely could accommodate two people. He had a sudden memory, almost physical in its intensity, of how amazing it had been to travel with a woman on his arm and to refer to “my wife” when he spoke to porters or conductors. How odd it would seem "), _c('i', [_vm._v("not ")]), _vm._v("to travel with her now! “A lot has happened,” he said, savoring the aftertaste of the memory even as it receded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e658744"
    }
  }, [_vm._v("She looked skeptical. “I don’t know how much will have changed from your parents’ point of view.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e659744"
    }
  }, [_vm._v("“A lot’s happened in the world,” Tejada pointed out. “People felt more strongly about the Reds in 1940.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e661044"
    }
  }, [_vm._v("Elena raised her eyebrows. “I haven’t noticed any great resurgence of the Communists.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e662244"
    }
  }, [_vm._v("“Your father was never actually a Communist,” Tejada protested, scrupulously censoring the knowledge that Elena herself had been a Socialist during and before the war. It was not a piece of information he planned to share with any of his family. “He supported the Republic, but so did lots of people.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e664944"
    }
  }, [_vm._v("“And the important thing now is to be anti-Communist?” Elena said dryly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e666144"
    }
  }, [_vm._v("Tejada winced. It had always been important to be anti- Communist. And in Potes, perhaps, little had changed in the last five years. The peasants of the town were—he did not delude himself—mostly Reds and always had been. They would continue exactly as before regardless of the world outside the valley of Liébana. The Guardia would continue to maintain order, suppressing the peasants’ guerrilla activities as necessary. But he suspected that in his family’s world—the world of businessmen and landholders—the black and white that had defined the two sides in the Civil War were beginning to blur into shades of gray. In the summer of 1940 the Axis had looked invincible, and the Old Blue Shirts of Spain’s own Fascist Party had been an important part of the government. Now things were changing. He did not know how much. He was almost afraid to think how much. But they might change just enough to make his parents courteous to the daughter of an old-fashioned liberal. He edged away from the thought, ashamed that he was capable of believing his own parents would be guilty of trimming their political beliefs to the prevailing winds and ashamed of hoping that their hypocrisy would make them kinder to Elena. “Well, I’m afraid nothing can clear you of being from Salamanca,” he said aloud, trying to speak lightly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e675545"
    }
  }, [_vm._v("Elena shook her head in mock disapproval. “And you could have married a hot-blooded Andalusian,” she teased.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e676845"
    }
  }, [_vm._v("Tejada laughed, and put one arm around her. “I think I remember having this discussion five years ago,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e678045"
    }
  }, [_vm._v("Elena kissed him. “Some things haven’t changed,” she said smugly, and the conversation turned to other things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e679045"
    }
  }, [_vm._v("Toño was returned promptly at ten, with thanks from his hosts. He was tired and well fed enough to fall asleep shortly afterward. Tejada and his wife put out the lights in the compartment and watched the dusk deepen to royal blue and then to the star-pierced black of night in rural Andalusia. A little before four in the morning the night was banished by the lights of a city. Elena roused a sleepy Toño, who was inclined to be  cranky, and made him put his shoes on just as the train creaked to a stop and the cry “Granada! Station stop, Granada!” echoed through the train.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e684346"
    }
  }, [_vm._v("Toño was too sleepy to have a clear impression of the train station. He had a confused memory of trying to lie down on one of the trunks and of his parents conferring rapidly above him, and then his mother picked him up and he was carried out of the station past a line of horse-drawn taxis to a large car that gleamed black under the streetlights. A man with a mustache who looked like his father said, “So this is Carlos Antonio!” and then he was curled in his mother’s lap, too tired to keep his eyes open even though he was moving again. He was tired of being always in motion. Finally, his mother stood up and carried him what seemed like a long distance, and he started to cry a little because he wanted to stay where he was and he didn’t "), _c('i', [_vm._v("want ")]), _vm._v("to be carried anymore, but then she put him down and kissed him good night in what was unmistakably a real bed that wasn’t moving. His true memories of Granada started the next morning.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f03b817","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pawe_9781569477786_epub_c11_r1.vue
// module id = 87
// module chunks = 0